import {NameLabelColor} from '../../vendor/react-native-tapnovel-viewer';

export default NameLabelColor;
